module.exports = __webpack_public_path__ + "img/Icon-TouchFile.8541e4b1.svg";